import React from 'react';
import { FaUsers, FaHandshake, FaLightbulb } from 'react-icons/fa';
import aboutImage from '../assets/AboutUs/Team1.jpg';
import AboutSection from '../components/AboutSection';

export default function About() {
  return (
    <AboutSection />
  );
}
